import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { CoreComponent } from './core/core.component'
import { NotFoundComponent } from './not-found/not-found.component'
import { CaseResolver } from './shared/resolvers/case.resolver'
import { LoginComponent } from './login/login.component'
import { CaseViewerComponent } from './case-viewer/case-viewer.component'
import { LoginResolver } from './shared/resolvers/login.resolver'
import { CasesResolver } from './shared/resolvers/cases.resolver'
import { AuthGuard } from './shared/guards/auth.guard'
import { NoCaseComponent } from './case-management/no-case/no-case.component'
import { SharedCaseResolver } from './shared/resolvers/shared-case.resolver'

const routes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
        resolve: {
            redirect: LoginResolver,
        },
    },
    {
        path: 'shared/cases',
        component: CoreComponent,
        children: [
            {
                path: ':caseId',
                component: CaseViewerComponent,
                resolve: {
                    case: SharedCaseResolver,
                },
            },
            {
                path: '',
                redirectTo: '/404',
                pathMatch: 'full',
            },
        ],
    },
    {
        path: 'cases',
        component: CoreComponent,
        resolve: {
            cases: CasesResolver,
        },
        canActivate: [AuthGuard],
        children: [
            {
                path: ':caseId',
                component: CaseViewerComponent,
                resolve: {
                    case: CaseResolver,
                },
            },
            {
                path: '',
                component: NoCaseComponent,
            },
        ],
    },
    {
        path: '',
        redirectTo: '/cases',
        pathMatch: 'full',
    },
    {
        path: '404',
        component: NotFoundComponent,
    },
    {
        path: '**',
        redirectTo: '/404',
    },
]

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
